import { Icon } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';
import { useCurrentSpace } from '../../nav/use-current-space';

/** The space in the user card too (header proposal 11), with what each one is for. The same
 *  choice as the switch of the topbar; shown only to who has both. */
export function SpaceChoice({ onChosen }: { onChosen: () => void }) {
  const { t } = useTranslation();
  const { spaces, current, choose } = useCurrentSpace();
  if (spaces.length < 2 || current === null) return null;
  return (
    <div className="uc-sec" role="group" aria-labelledby="uc-space">
      <p className="mlabel" id="uc-space">
        {t('shell.spaces.label')}
      </p>
      <div className="uc-spaces">
        {spaces.map((space) => (
          <button
            key={space.key}
            type="button"
            aria-pressed={space.key === current.key}
            onClick={() => {
              choose(space.key);
              onChosen();
            }}
          >
            <Icon name={space.space.icon} size={22} />
            <b>{t(`shell.spaces.${space.key}`)}</b>
            <span>{t(`shell.spaces.hints.${space.key}`)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
